import { ReactElement } from 'react'
import { Navigate } from 'react-router-dom'

type Props = {
  children: Element | ReactElement
  hasUser: boolean
}

export const ProtectedRoute = ({ children, hasUser }: Props) => {
  return <> {!hasUser ? <Navigate to='/login' replace /> : children}</>
}
